import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { HttpQueueService } from './services/http-queue.service';

export function queueRequestsInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  if (!request.url.startsWith(environment.apiBaseUrl)) {
    return next(request);
  }

  const httpQueueService = inject(HttpQueueService);

  return httpQueueService.enqueue(request, next);
}
